import { Text } from "@overmap-ai/blocks"
import type { User } from "@overmap-ai/common"
import { forwardRef, memo } from "react"

import { UserIcon } from "../../../components/Icons/UserIcon"
import { getUserDisplayLabel } from "../../../utils/users"
import {
	MentionListEmpty,
	MentionListItem,
	type MentionListRef,
	MentionListRoot,
	type MentionListRootProps,
} from "../../blocks"

type UserMentionListProps = MentionListRootProps<User>

export const UserMentionList = memo(
	forwardRef<MentionListRef<User>, UserMentionListProps>((props, ref) => {
		const { items } = props

		return (
			<MentionListRoot<User> ref={ref} {...props}>
				{items.map((user) => (
					<MentionListItem<User> item={user} key={user.id}>
						<UserIcon userId={user.id} className="h-4 w-4" />
						<Text className="truncate">{getUserDisplayLabel(user)}</Text>
					</MentionListItem>
				))}
				<MentionListEmpty>No results</MentionListEmpty>
			</MentionListRoot>
		)
	}),
)
UserMentionList.displayName = "UserMentionList"
